// AUTO-GENERATED by scripts/build-icons.mjs — do not edit by hand.
import { createSvgIconFromGenerated } from '../utils'

import SvgAdd from './svg-add'
import SvgAddFilled from './svg-add-filled'
import SvgAddOutline from './svg-add-outline'
import SvgAnswer from './svg-answer'
import SvgApplePay from './svg-apple-pay'
import SvgArrowRight from './svg-arrow-right'
import SvgAtm from './svg-atm'
import SvgAttachment from './svg-attachment'
import SvgBack from './svg-back'
import SvgBackspace from './svg-backspace'
import SvgBank from './svg-bank'
import SvgBillCheck from './svg-bill-check'
import SvgBillFilled from './svg-bill-filled'
import SvgBillOutline from './svg-bill-outline'
import SvgBlik from './svg-blik'
import SvgBullet from './svg-bullet'
import SvgCalendar from './svg-calendar'
import SvgCamera from './svg-camera'
import SvgCardAdd from './svg-card-add'
import SvgCardChange from './svg-card-change'
import SvgCardCheck from './svg-card-check'
import SvgCardCross from './svg-card-cross'
import SvgCardCrossed from './svg-card-crossed'
import SvgCardCvv from './svg-card-cvv'
import SvgCardFilled from './svg-card-filled'
import SvgCardInstallments from './svg-card-installments'
import SvgCardOutline from './svg-card-outline'
import SvgCartFilled from './svg-cart-filled'
import SvgCartOutline from './svg-cart-outline'
import SvgCashFilled from './svg-cash-filled'
import SvgCashOutline from './svg-cash-outline'
import SvgCashback from './svg-cashback'
import SvgCategories from './svg-categories'
import SvgChartFilled from './svg-chart-filled'
import SvgChartOutline from './svg-chart-outline'
import SvgCheckMark from './svg-check-mark'
import SvgCheckmarkFilled from './svg-checkmark-filled'
import SvgCheckmarkOutline from './svg-checkmark-outline'
import SvgChevronDown from './svg-chevron-down'
import SvgChevronLeft from './svg-chevron-left'
import SvgChevronLeftAlt from './svg-chevron-left-alt'
import SvgChevronRight from './svg-chevron-right'
import SvgChevronRightAlt from './svg-chevron-right-alt'
import SvgChevronUp from './svg-chevron-up'
import SvgClickToPay from './svg-click-to-pay'
import SvgClock from './svg-clock'
import SvgClose from './svg-close'
import SvgCloseBold from './svg-close-bold'
import SvgContactless from './svg-contactless'
import SvgCopy from './svg-copy'
import SvgCreditsFilled from './svg-credits-filled'
import SvgCreditsOutline from './svg-credits-outline'
import SvgCrossmarkFilled from './svg-crossmark-filled'
import SvgCrossmarkOutline from './svg-crossmark-outline'
import SvgDeals from './svg-deals'
import SvgDecrease from './svg-decrease'
import SvgDeferral from './svg-deferral'
import SvgDeleteFilled from './svg-delete-filled'
import SvgDeleteOutline from './svg-delete-outline'
import SvgDelivery from './svg-delivery'
import SvgDesktop from './svg-desktop'
import SvgDetails from './svg-details'
import SvgDirectDebit from './svg-direct-debit'
import SvgDonations from './svg-donations'
import SvgDownPayment from './svg-down-payment'
import SvgDownload from './svg-download'
import SvgEdit from './svg-edit'
import SvgEmail from './svg-email'
import SvgEmailAdd from './svg-email-add'
import SvgExpensesFilled from './svg-expenses-filled'
import SvgExpensesOutline from './svg-expenses-outline'
import SvgExpress from './svg-express'
import SvgExpressAlt from './svg-express-alt'
import SvgEye from './svg-eye'
import SvgEyeOff from './svg-eye-off'
import SvgFaceId from './svg-face-id'
import SvgFastBankTransfer from './svg-fast-bank-transfer'
import SvgFileDownload from './svg-file-download'
import SvgFileFilled from './svg-file-filled'
import SvgFileOutline from './svg-file-outline'
import SvgFileUpload from './svg-file-upload'
import SvgFilter from './svg-filter'
import SvgFilterActive from './svg-filter-active'
import SvgFingerprint from './svg-fingerprint'
import SvgFlash from './svg-flash'
import SvgFlashOff from './svg-flash-off'
import SvgForward from './svg-forward'
import SvgFullReturn from './svg-full-return'
import SvgFxRateFilled from './svg-fx-rate-filled'
import SvgFxRateOutline from './svg-fx-rate-outline'
import SvgGhostDone from './svg-ghost-done'
import SvgGif from './svg-gif'
import SvgGiftFilled from './svg-gift-filled'
import SvgGiftOutline from './svg-gift-outline'
import SvgGooglePay from './svg-google-pay'
import SvgGraph from './svg-graph'
import SvgHome from './svg-home'
import SvgHomeFilled from './svg-home-filled'
import SvgImage from './svg-image'
import SvgInfo from './svg-info'
import SvgInstallmentsExisting from './svg-installments-existing'
import SvgInstallmentsFilled from './svg-installments-filled'
import SvgInstallmentsFree from './svg-installments-free'
import SvgInstallmentsNew from './svg-installments-new'
import SvgInstallmentsOutline from './svg-installments-outline'
import SvgInsuranceFilled from './svg-insurance-filled'
import SvgInsuranceOutline from './svg-insurance-outline'
import SvgLaw from './svg-law'
import SvgLimits from './svg-limits'
import SvgLink from './svg-link'
import SvgList from './svg-list'
import SvgLocation from './svg-location'
import SvgLock from './svg-lock'
import SvgLogout from './svg-logout'
import SvgMap from './svg-map'
import SvgMenu from './svg-menu'
import SvgMessage from './svg-message'
import SvgModeAuto from './svg-mode-auto'
import SvgModeDark from './svg-mode-dark'
import SvgModeLight from './svg-mode-light'
import SvgMoreFilled from './svg-more-filled'
import SvgMoreOutline from './svg-more-outline'
import SvgMoreVertical from './svg-more-vertical'
import SvgNote from './svg-note'
import SvgNotification from './svg-notification'
import SvgNumberFour from './svg-number-four'
import SvgNumberOne from './svg-number-one'
import SvgNumberThree from './svg-number-three'
import SvgNumberTwo from './svg-number-two'
import SvgOnlineShopping from './svg-online-shopping'
import SvgPartialRefund from './svg-partial-refund'
import SvgPause from './svg-pause'
import SvgPayInN from './svg-pay-in-n'
import SvgPendingFilled from './svg-pending-filled'
import SvgPendingOutline from './svg-pending-outline'
import SvgPhone from './svg-phone'
import SvgPhoneAdd from './svg-phone-add'
import SvgPhonePay from './svg-phone-pay'
import SvgPhysicalCards from './svg-physical-cards'
import SvgPig from './svg-pig'
import SvgPin from './svg-pin'
import SvgPlay from './svg-play'
import SvgQr from './svg-qr'
import SvgReceipt from './svg-receipt'
import SvgReceiptAdd from './svg-receipt-add'
import SvgRedirect from './svg-redirect'
import SvgRefresh from './svg-refresh'
import SvgRemove from './svg-remove'
import SvgRemoveFilled from './svg-remove-filled'
import SvgRemoveOutline from './svg-remove-outline'
import SvgReturn from './svg-return'
import SvgRotate from './svg-rotate'
import SvgScan from './svg-scan'
import SvgSearch from './svg-search'
import SvgSecurity from './svg-security'
import SvgSend from './svg-send'
import SvgSettingsFilled from './svg-settings-filled'
import SvgSettingsOutline from './svg-settings-outline'
import SvgShare from './svg-share'
import SvgShoppingFilled from './svg-shopping-filled'
import SvgShoppingOutline from './svg-shopping-outline'
import SvgSlider from './svg-slider'
import SvgSnapAdd from './svg-snap-add'
import SvgSnapCheck from './svg-snap-check'
import SvgSnapCross from './svg-snap-cross'
import SvgSnapFilled from './svg-snap-filled'
import SvgSnapOutline from './svg-snap-outline'
import SvgSnapPending from './svg-snap-pending'
import SvgSort from './svg-sort'
import SvgSound from './svg-sound'
import SvgSplit from './svg-split'
import SvgSwipeDown from './svg-swipe-down'
import SvgTooltipFilled from './svg-tooltip-filled'
import SvgTooltipOutline from './svg-tooltip-outline'
import SvgTopUp from './svg-top-up'
import SvgTransfersOutline from './svg-transfers-outline'
import SvgTwistoAppLogo from './svg-twisto-app-logo'
import SvgTwistoAppLogoShort from './svg-twisto-app-logo-short'
import SvgTwistoFilled from './svg-twisto-filled'
import SvgTwistoOutline from './svg-twisto-outline'
import SvgTwistoPayFilled from './svg-twisto-pay-filled'
import SvgTwistoPayOutline from './svg-twisto-pay-outline'
import SvgUnlink from './svg-unlink'
import SvgUnlock from './svg-unlock'
import SvgUpload from './svg-upload'
import SvgUserAdd from './svg-user-add'
import SvgUserCross from './svg-user-cross'
import SvgUserFilled from './svg-user-filled'
import SvgUserOutline from './svg-user-outline'
import SvgVideo from './svg-video'
import SvgWarningFilled from './svg-warning-filled'
import SvgWarningOutline from './svg-warning-outline'
import SvgWorld from './svg-world'

export const AddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgAdd, 'Add')
export const AddFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgAddFilled, 'AddFilled')
export const AddOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgAddOutline, 'AddOutline')
export const AnswerIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgAnswer, 'Answer')
export const ApplePayIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgApplePay, 'ApplePay')
export const ArrowRightIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgArrowRight, 'ArrowRight')
export const AtmIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgAtm, 'Atm')
export const AttachmentIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgAttachment, 'Attachment')
export const BackIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBack, 'Back')
export const BackspaceIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBackspace, 'Backspace')
export const BankIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBank, 'Bank')
export const BillCheckIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBillCheck, 'BillCheck')
export const BillFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBillFilled, 'BillFilled')
export const BillOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBillOutline, 'BillOutline')
export const BlikIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBlik, 'Blik')
export const BulletIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgBullet, 'Bullet')
export const CalendarIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCalendar, 'Calendar')
export const CameraIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCamera, 'Camera')
export const CardAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCardAdd, 'CardAdd')
export const CardChangeIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCardChange, 'CardChange')
export const CardCheckIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCardCheck, 'CardCheck')
export const CardCrossIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCardCross, 'CardCross')
export const CardCrossedIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCardCrossed, 'CardCrossed')
export const CardCvvIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCardCvv, 'CardCvv')
export const CardFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCardFilled, 'CardFilled')
export const CardInstallmentsIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCardInstallments, 'CardInstallments')
export const CardOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCardOutline, 'CardOutline')
export const CartFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCartFilled, 'CartFilled')
export const CartOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCartOutline, 'CartOutline')
export const CashFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCashFilled, 'CashFilled')
export const CashOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCashOutline, 'CashOutline')
export const CashbackIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCashback, 'Cashback')
export const CategoriesIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCategories, 'Categories')
export const ChartFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgChartFilled, 'ChartFilled')
export const ChartOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgChartOutline, 'ChartOutline')
export const CheckMarkIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCheckMark, 'CheckMark')
export const CheckmarkFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCheckmarkFilled, 'CheckmarkFilled')
export const CheckmarkOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCheckmarkOutline, 'CheckmarkOutline')
export const ChevronDownIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgChevronDown, 'ChevronDown')
export const ChevronLeftIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgChevronLeft, 'ChevronLeft')
export const ChevronLeftAltIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgChevronLeftAlt, 'ChevronLeftAlt')
export const ChevronRightIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgChevronRight, 'ChevronRight')
export const ChevronRightAltIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgChevronRightAlt, 'ChevronRightAlt')
export const ChevronUpIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgChevronUp, 'ChevronUp')
export const ClickToPayIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgClickToPay, 'ClickToPay')
export const ClockIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgClock, 'Clock')
export const CloseIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgClose, 'Close')
export const CloseBoldIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCloseBold, 'CloseBold')
export const ContactlessIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgContactless, 'Contactless')
export const CopyIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCopy, 'Copy')
export const CreditsFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCreditsFilled, 'CreditsFilled')
export const CreditsOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCreditsOutline, 'CreditsOutline')
export const CrossmarkFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCrossmarkFilled, 'CrossmarkFilled')
export const CrossmarkOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgCrossmarkOutline, 'CrossmarkOutline')
export const DealsIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDeals, 'Deals')
export const DecreaseIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDecrease, 'Decrease')
export const DeferralIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDeferral, 'Deferral')
export const DeleteFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDeleteFilled, 'DeleteFilled')
export const DeleteOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDeleteOutline, 'DeleteOutline')
export const DeliveryIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDelivery, 'Delivery')
export const DesktopIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDesktop, 'Desktop')
export const DetailsIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDetails, 'Details')
export const DirectDebitIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDirectDebit, 'DirectDebit')
export const DonationsIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDonations, 'Donations')
export const DownPaymentIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDownPayment, 'DownPayment')
export const DownloadIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgDownload, 'Download')
export const EditIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgEdit, 'Edit')
export const EmailIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgEmail, 'Email')
export const EmailAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgEmailAdd, 'EmailAdd')
export const ExpensesFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgExpensesFilled, 'ExpensesFilled')
export const ExpensesOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgExpensesOutline, 'ExpensesOutline')
export const ExpressIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgExpress, 'Express')
export const ExpressAltIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgExpressAlt, 'ExpressAlt')
export const EyeIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgEye, 'Eye')
export const EyeOffIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgEyeOff, 'EyeOff')
export const FaceIdIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFaceId, 'FaceId')
export const FastBankTransferIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFastBankTransfer, 'FastBankTransfer')
export const FileDownloadIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFileDownload, 'FileDownload')
export const FileFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFileFilled, 'FileFilled')
export const FileOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFileOutline, 'FileOutline')
export const FileUploadIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFileUpload, 'FileUpload')
export const FilterIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFilter, 'Filter')
export const FilterActiveIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFilterActive, 'FilterActive')
export const FingerprintIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFingerprint, 'Fingerprint')
export const FlashIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFlash, 'Flash')
export const FlashOffIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFlashOff, 'FlashOff')
export const ForwardIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgForward, 'Forward')
export const FullReturnIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFullReturn, 'FullReturn')
export const FxRateFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFxRateFilled, 'FxRateFilled')
export const FxRateOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgFxRateOutline, 'FxRateOutline')
export const GhostDoneIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgGhostDone, 'GhostDone')
export const GifIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgGif, 'Gif')
export const GiftFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgGiftFilled, 'GiftFilled')
export const GiftOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgGiftOutline, 'GiftOutline')
export const GooglePayIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgGooglePay, 'GooglePay')
export const GraphIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgGraph, 'Graph')
export const HomeIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgHome, 'Home')
export const HomeFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgHomeFilled, 'HomeFilled')
export const ImageIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgImage, 'Image')
export const InfoIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgInfo, 'Info')
export const InstallmentsExistingIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgInstallmentsExisting, 'InstallmentsExisting')
export const InstallmentsFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgInstallmentsFilled, 'InstallmentsFilled')
export const InstallmentsFreeIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgInstallmentsFree, 'InstallmentsFree')
export const InstallmentsNewIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgInstallmentsNew, 'InstallmentsNew')
export const InstallmentsOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgInstallmentsOutline, 'InstallmentsOutline')
export const InsuranceFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgInsuranceFilled, 'InsuranceFilled')
export const InsuranceOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgInsuranceOutline, 'InsuranceOutline')
export const LawIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgLaw, 'Law')
export const LimitsIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgLimits, 'Limits')
export const LinkIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgLink, 'Link')
export const ListIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgList, 'List')
export const LocationIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgLocation, 'Location')
export const LockIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgLock, 'Lock')
export const LogoutIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgLogout, 'Logout')
export const MapIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgMap, 'Map')
export const MenuIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgMenu, 'Menu')
export const MessageIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgMessage, 'Message')
export const ModeAutoIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgModeAuto, 'ModeAuto')
export const ModeDarkIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgModeDark, 'ModeDark')
export const ModeLightIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgModeLight, 'ModeLight')
export const MoreFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgMoreFilled, 'MoreFilled')
export const MoreOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgMoreOutline, 'MoreOutline')
export const MoreVerticalIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgMoreVertical, 'MoreVertical')
export const NoteIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgNote, 'Note')
export const NotificationIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgNotification, 'Notification')
export const NumberFourIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgNumberFour, 'NumberFour')
export const NumberOneIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgNumberOne, 'NumberOne')
export const NumberThreeIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgNumberThree, 'NumberThree')
export const NumberTwoIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgNumberTwo, 'NumberTwo')
export const OnlineShoppingIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgOnlineShopping, 'OnlineShopping')
export const PartialRefundIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPartialRefund, 'PartialRefund')
export const PauseIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPause, 'Pause')
export const PayInNIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPayInN, 'PayInN')
export const PendingFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPendingFilled, 'PendingFilled')
export const PendingOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPendingOutline, 'PendingOutline')
export const PhoneIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPhone, 'Phone')
export const PhoneAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPhoneAdd, 'PhoneAdd')
export const PhonePayIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPhonePay, 'PhonePay')
export const PhysicalCardsIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPhysicalCards, 'PhysicalCards')
export const PigIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPig, 'Pig')
export const PinIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPin, 'Pin')
export const PlayIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgPlay, 'Play')
export const QrIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgQr, 'Qr')
export const ReceiptIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgReceipt, 'Receipt')
export const ReceiptAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgReceiptAdd, 'ReceiptAdd')
export const RedirectIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgRedirect, 'Redirect')
export const RefreshIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgRefresh, 'Refresh')
export const RemoveIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgRemove, 'Remove')
export const RemoveFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgRemoveFilled, 'RemoveFilled')
export const RemoveOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgRemoveOutline, 'RemoveOutline')
export const ReturnIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgReturn, 'Return')
export const RotateIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgRotate, 'Rotate')
export const ScanIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgScan, 'Scan')
export const SearchIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSearch, 'Search')
export const SecurityIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSecurity, 'Security')
export const SendIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSend, 'Send')
export const SettingsFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSettingsFilled, 'SettingsFilled')
export const SettingsOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSettingsOutline, 'SettingsOutline')
export const ShareIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgShare, 'Share')
export const ShoppingFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgShoppingFilled, 'ShoppingFilled')
export const ShoppingOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgShoppingOutline, 'ShoppingOutline')
export const SliderIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSlider, 'Slider')
export const SnapAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSnapAdd, 'SnapAdd')
export const SnapCheckIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSnapCheck, 'SnapCheck')
export const SnapCrossIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSnapCross, 'SnapCross')
export const SnapFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSnapFilled, 'SnapFilled')
export const SnapOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSnapOutline, 'SnapOutline')
export const SnapPendingIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSnapPending, 'SnapPending')
export const SortIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSort, 'Sort')
export const SoundIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSound, 'Sound')
export const SplitIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSplit, 'Split')
export const SwipeDownIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgSwipeDown, 'SwipeDown')
export const TooltipFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTooltipFilled, 'TooltipFilled')
export const TooltipOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTooltipOutline, 'TooltipOutline')
export const TopUpIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTopUp, 'TopUp')
export const TransfersOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTransfersOutline, 'TransfersOutline')
export const TwistoAppLogoIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTwistoAppLogo, 'TwistoAppLogo')
export const TwistoAppLogoShortIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTwistoAppLogoShort, 'TwistoAppLogoShort')
export const TwistoFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTwistoFilled, 'TwistoFilled')
export const TwistoOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTwistoOutline, 'TwistoOutline')
export const TwistoPayFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTwistoPayFilled, 'TwistoPayFilled')
export const TwistoPayOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgTwistoPayOutline, 'TwistoPayOutline')
export const UnlinkIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgUnlink, 'Unlink')
export const UnlockIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgUnlock, 'Unlock')
export const UploadIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgUpload, 'Upload')
export const UserAddIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgUserAdd, 'UserAdd')
export const UserCrossIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgUserCross, 'UserCross')
export const UserFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgUserFilled, 'UserFilled')
export const UserOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgUserOutline, 'UserOutline')
export const VideoIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgVideo, 'Video')
export const WarningFilledIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgWarningFilled, 'WarningFilled')
export const WarningOutlineIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgWarningOutline, 'WarningOutline')
export const WorldIcon = /* #__PURE__*/ createSvgIconFromGenerated(SvgWorld, 'World')
